import { render, staticRenderFns } from "./ChatGpt.vue?vue&type=template&id=8f614f6a&scoped=true"
import script from "./ChatGpt.vue?vue&type=script&lang=js"
export * from "./ChatGpt.vue?vue&type=script&lang=js"
import style0 from "./ChatGpt.vue?vue&type=style&index=0&id=8f614f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f614f6a",
  null
  
)

export default component.exports